import styled from "styled-components";

export const TextoDescricao = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.neutral.neutral70};
  margin-bottom: 1rem;
`;

export const ContainerArquivo = styled.div`
  padding: 16px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
`;

export const ContainerBotoes = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;
